<script lang="ts">
	const companyInfo = {
		name: "Nikita Szulcsánová",
		tradeName: "Head Spa Napohodu",
		address: "Hrnčířská 42/5, 733 01 Karviná",
		phone: "+420 727 955 703",
		email: "info@headspa-napohodu.cz",
	};

	const collectedData = ["Jméno a příjmení", "E-mailová adresa", "Telefonní číslo", "Údaje o obdarovaném (u poukazů)"];

	const purposes = [
		"Komunikace s vámi na základě vašeho dotazu nebo objednávky",
		"Zpracování objednávek dárkových poukazů",
		"Rezervace a správa termínů procedur",
		"Zasílání informací souvisejících s vašimi objednávkami",
	];

	const securityMeasures = [
		"Přístup k údajům je omezen pouze na oprávněné osoby",
		"Data jsou uchovávána na zabezpečených serverech",
		"Používáme šifrování pro přenos citlivých údajů",
		"Pravidelně aktualizujeme bezpečnostní opatření",
	];

	const rights = [
		"Právo na přístup ke svým osobním údajům",
		"Právo na opravu nepřesných údajů",
		"Právo na výmaz údajů (právo být zapomenut)",
		"Právo na omezení zpracování",
		"Právo na přenositelnost údajů",
		"Právo vznést námitku proti zpracování",
		"Právo kdykoliv odvolat udělený souhlas se zpracováním (např. souhlas s cookies)",
	];

	const retentionPeriods = [
		{ label: "Údaje o objednávkách", period: "po dobu 3 let od poskytnutí služby" },
		{ label: "Kontaktní údaje z dotazů", period: "po dobu 1 roku od posledního kontaktu" },
		{ label: "Účetní doklady", period: "po dobu stanovenou zákonem (10 let)" },
		{ label: "Cookies (analytické a marketingové)", period: "po dobu platnosti souhlasu, maximálně 13 měsíců" },
	];

	const thirdParties = [
		"Google Ireland Limited (Google Analytics 4 – analýza návštěvnosti webu, na základě vašeho souhlasu)",
		"CookieScript (správa souhlasů s cookies – cookie lišta)",
		"Poskytovatelé hostingových služeb (pro provoz webových stránek)",
		"Státní orgány v případě zákonné povinnosti",
	];

	const cookieCategories = [
		{
			name: "Nezbytné cookies",
			description:
				"Tyto cookies jsou nutné pro správné fungování webových stránek. Zajišťují základní funkce, jako je navigace na stránce a přístup k zabezpečeným oblastem. Bez těchto cookies by web nemohl správně fungovat. Nevyžadují váš souhlas a nelze je vypnout.",
			examples: "session cookies, bezpečnostní cookies",
			consent: "Není vyžadován (oprávněný zájem)",
		},
		{
			name: "Analytické cookies",
			description:
				"Pomáhají nám porozumět tomu, jak návštěvníci používají naše stránky – jaké stránky navštěvují nejčastěji, jak dlouho se na nich zdržují apod. Data jsou zpracovávána službou Google Analytics 4 (GA4) a slouží ke zlepšování našeho webu. Tyto cookies se aktivují pouze po udělení vašeho souhlasu.",
			examples: "_ga, _ga_*",
			consent: "Vyžadován váš souhlas",
		},
		{
			name: "Marketingové cookies",
			description:
				"Umožňují zobrazování relevantních reklam v rámci reklamní sítě Google. Bez vašeho souhlasu se tyto cookies neukládají a reklamy nejsou personalizovány.",
			examples: "cookies reklamní sítě Google",
			consent: "Vyžadován váš souhlas",
		},
	];
</script>

<section class="flex flex-col justify-center items-center gap-8 sm:gap-12 md:gap-16 overflow-x-clip full-width">
	<div class="flex flex-col items-center gap-6 sm:gap-8 md:gap-12 w-full container-center px-4 xl:px-0">
		<h1 class="">Ochrana osobních údajů</h1>

		<div class="flex flex-col items-start gap-6 sm:gap-8 md:gap-12 w-full max-w-[55rem]">
			<!-- Úvod -->
			<div class="flex flex-col gap-3 sm:gap-4">
				<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
					Ochrana vašich osobních údajů je pro nás prioritou. Tento dokument vás informuje o tom, jak zpracováváme vaše
					osobní údaje a jak používáme cookies, v souladu s nařízením GDPR, zákonem č. 110/2019 Sb., o zpracování
					osobních údajů, a směrnicí ePrivacy.
				</p>
			</div>

			<!-- Totožnost správce -->
			<div class="flex flex-col gap-3 sm:gap-4 md:gap-5 w-full">
				<h2 class="text-left">Totožnost a kontaktní údaje správce</h2>
				<div class="flex flex-col gap-2 sm:gap-3">
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
						<span class="text-midnight/60">Jméno:</span>
						{companyInfo.name}
					</p>
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
						<span class="text-midnight/60">Provozovna:</span>
						{companyInfo.tradeName}
					</p>
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
						<span class="text-midnight/60">Adresa:</span>
						{companyInfo.address}
					</p>
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
						<span class="text-midnight/60">Telefon:</span>
						<a href="tel:{companyInfo.phone}" class="text-copper-300 hover:text-copper-200 transition-colors">
							{companyInfo.phone}
						</a>
					</p>
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
						<span class="text-midnight/60">E-mail:</span>
						<a href="mailto:{companyInfo.email}" class="text-copper-300 hover:text-copper-200 transition-colors">
							{companyInfo.email}
						</a>
					</p>
				</div>
			</div>

			<!-- Shromažďované údaje -->
			<div class="flex flex-col gap-3 sm:gap-4 md:gap-5 w-full">
				<h2 class="text-left">Jaké osobní údaje shromažďujeme?</h2>
				<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
					Shromažďujeme pouze osobní údaje, které nám dobrovolně poskytnete při objednávce služeb nebo kontaktování.
					Jedná se o:
				</p>
				<ul class="flex flex-col gap-2">
					{#each collectedData as item, index (index)}
						<li
							class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight flex items-start gap-2"
						>
							<span class="text-copper-300">•</span>
							{item}
						</li>
					{/each}
				</ul>
			</div>

			<!-- Účely zpracování -->
			<div class="flex flex-col gap-3 sm:gap-4 md:gap-5 w-full">
				<h2 class="text-left">Za jakým účelem údaje zpracováváme?</h2>
				<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
					Vaše osobní údaje zpracováváme výhradně pro následující účely:
				</p>
				<ul class="flex flex-col gap-2">
					{#each purposes as item, index (index)}
						<li
							class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight flex items-start gap-2"
						>
							<span class="text-copper-300">•</span>
							{item}
						</li>
					{/each}
				</ul>
				<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight/60">
					Vaše údaje nevyužíváme k žádným marketingovým účelům bez vašeho předchozího výslovného souhlasu.
				</p>
			</div>

			<!-- Doba uchování -->
			<div class="flex flex-col gap-3 sm:gap-4 md:gap-5 w-full">
				<h2 class="text-left">Doba uchování údajů</h2>
				<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
					Vaše osobní údaje uchováváme pouze po dobu nezbytně nutnou pro splnění účelu, pro který byly shromážděny:
				</p>
				<ul class="flex flex-col gap-2">
					{#each retentionPeriods as item, index (index)}
						<li
							class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight flex items-start gap-2"
						>
							<span class="text-copper-300">•</span>
							<span><strong>{item.label}:</strong> {item.period}</span>
						</li>
					{/each}
				</ul>
			</div>

			<!-- Sdílení s třetími stranami -->
			<div class="flex flex-col gap-3 sm:gap-4 md:gap-5 w-full">
				<h2 class="text-left">Sdílení údajů s třetími stranami</h2>
				<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
					Vaše osobní údaje nesdílíme s třetími stranami pro marketingové účely. Údaje můžeme sdílet pouze v těchto
					případech:
				</p>
				<ul class="flex flex-col gap-2">
					{#each thirdParties as item, index (index)}
						<li
							class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight flex items-start gap-2"
						>
							<span class="text-copper-300">•</span>
							{item}
						</li>
					{/each}
				</ul>
				<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight/60">
					Data předávaná společnosti Google mohou být zpracovávána na serverech mimo EU. Google zajišťuje odpovídající
					úroveň ochrany na základě standardních smluvních doložek (SCC).
				</p>
			</div>

			<!-- Bezpečnost -->
			<div class="flex flex-col gap-3 sm:gap-4 md:gap-5 w-full">
				<h2 class="text-left">Bezpečnostní opatření</h2>
				<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
					Pro ochranu vašich osobních údajů jsme zavedli následující opatření:
				</p>
				<ul class="flex flex-col gap-2">
					{#each securityMeasures as item, index (index)}
						<li
							class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight flex items-start gap-2"
						>
							<span class="text-copper-300">•</span>
							{item}
						</li>
					{/each}
				</ul>
			</div>

			<!-- Cookies -->
			<div class="flex flex-col gap-3 sm:gap-4 md:gap-5 w-full">
				<h2 class="text-left">Co jsou cookies?</h2>
				<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
					Cookies jsou malé textové soubory, které se ukládají do vašeho prohlížeče při návštěvě webových stránek.
					Pomáhají nám zajistit správné fungování webu a lépe porozumět tomu, jak ho návštěvníci používají.
				</p>
			</div>

			<div class="flex flex-col gap-3 sm:gap-4 md:gap-5 w-full">
				<h2 class="text-left">Jaké kategorie cookies používáme?</h2>
				<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
					Cookies na našem webu dělíme do tří kategorií:
				</p>
				<div class="flex flex-col gap-5 sm:gap-6">
					{#each cookieCategories as category, index (index)}
						<div class="flex flex-col gap-2">
							<p
								class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-semibold leading-[140%] text-midnight"
							>
								{index + 1}. {category.name}
							</p>
							<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
								{category.description}
							</p>
							<p
								class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight/60"
							>
								<span class="text-midnight/40">Příklady:</span>
								{category.examples}
							</p>
							<p
								class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight/60"
							>
								<span class="text-midnight/40">Souhlas:</span>
								{category.consent}
							</p>
						</div>
					{/each}
				</div>
			</div>

			<!-- Consent Mode -->
			<div class="flex flex-col gap-3 sm:gap-4 md:gap-5 w-full">
				<h2 class="text-left">Jak chráníme vaše soukromí (Google Consent Mode v2)</h2>
				<div class="flex flex-col gap-3 sm:gap-4">
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
						Na našem webu máme nasazený Google Consent Mode v2 – moderní technologii, která zajišťuje plné respektování
						vašeho rozhodnutí o cookies. V praxi to funguje takto:
					</p>
					<ul class="flex flex-col gap-2">
						<li
							class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight flex items-start gap-2"
						>
							<span class="text-copper-300">•</span>
							<span
								><strong>Dokud neudělíte souhlas</strong> – veškeré cookies služby Google Analytics jsou ve výchozím
								stavu <em>zakázané</em>. Do Google se odesílají pouze anonymní, tzv. cookieless pingy, které neobsahují
								žádné osobní údaje a nelze z nich identifikovat konkrétního uživatele.</span
							>
						</li>
						<li
							class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight flex items-start gap-2"
						>
							<span class="text-copper-300">•</span>
							<span
								><strong>Po udělení souhlasu</strong> – teprve když v cookie liště kliknete na „Souhlasím" (případně povolíte
								konkrétní kategorie), aktivují se příslušné cookies a Google Analytics začne sbírat plná analytická data.</span
							>
						</li>
						<li
							class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight flex items-start gap-2"
						>
							<span class="text-copper-300">•</span>
							<span
								><strong>Souhlas můžete kdykoliv odvolat</strong> – stačí kliknout na ikonku CookieScriptu v rohu obrazovky
								a změnit svá nastavení. Změna se projeví okamžitě.</span
							>
						</li>
					</ul>
				</div>
			</div>

			<!-- Správa cookies -->
			<div class="flex flex-col gap-3 sm:gap-4 md:gap-5 w-full">
				<h2 class="text-left">Jak změnit nebo odvolat souhlas s cookies?</h2>
				<div class="flex flex-col gap-3 sm:gap-4">
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
						Máte několik možností, jak spravovat své preference cookies:
					</p>
					<ul class="flex flex-col gap-2">
						<li
							class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight flex items-start gap-2"
						>
							<span class="text-copper-300">•</span>
							<span
								><strong>Cookie lišta (CookieScript)</strong> – při první návštěvě se zobrazí lišta, kde si zvolíte, které
								kategorie cookies povolíte. Své rozhodnutí můžete kdykoliv změnit kliknutím na ikonu cookie v rohu stránky.</span
							>
						</li>
						<li
							class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight flex items-start gap-2"
						>
							<span class="text-copper-300">•</span>
							<span
								><strong>Nastavení prohlížeče</strong> – ve svém prohlížeči můžete cookies blokovat nebo mazat. Návod najdete
								v nápovědě vašeho prohlížeče.</span
							>
						</li>
					</ul>
				</div>
			</div>

			<!-- Vaše práva -->
			<div class="flex flex-col gap-3 sm:gap-4 md:gap-5 w-full">
				<h2 class="text-left">Vaše práva</h2>
				<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
					V souvislosti se zpracováním vašich osobních údajů máte následující práva:
				</p>
				<ul class="flex flex-col gap-2">
					{#each rights as item, index (index)}
						<li
							class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight flex items-start gap-2"
						>
							<span class="text-copper-300">•</span>
							{item}
						</li>
					{/each}
				</ul>
				<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
					Pro uplatnění svých práv nás kontaktujte na e-mailu
					<a href="mailto:{companyInfo.email}" class="text-copper-300 hover:text-copper-200 transition-colors">
						{companyInfo.email}</a
					>.
				</p>
			</div>

			<!-- Dozorový úřad -->
			<div class="flex flex-col gap-3 sm:gap-4 md:gap-5 w-full">
				<h2 class="text-left">Dozorový úřad</h2>
				<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
					Pokud se domníváte, že zpracování vašich osobních údajů porušuje nařízení GDPR, máte právo podat stížnost u
					dozorového úřadu:
				</p>
				<div class="flex flex-col gap-1">
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-semibold leading-[140%] text-midnight">
						Úřad pro ochranu osobních údajů
					</p>
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight/80">
						Pplk. Sochora 27, 170 00 Praha 7
					</p>
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight/80">
						Web:
						<a
							href="https://www.uoou.cz"
							target="_blank"
							rel="noopener noreferrer"
							class="text-copper-300 hover:text-copper-200 transition-colors"
						>
							www.uoou.cz
						</a>
					</p>
				</div>
			</div>

			<!-- Aktualizace -->
			<div class="flex flex-col gap-3 sm:gap-4 w-full">
				<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight/60">
					Tento dokument může být příležitostně aktualizován. Aktuální verze je vždy dostupná na těchto stránkách.
				</p>
				<p class="font-inter text-[10px] sm:text-xs md:text-sm font-medium leading-[140%] text-midnight/40">
					Poslední aktualizace: březen 2026
				</p>
			</div>
		</div>
	</div>
</section>
